// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1a1XO","col":"styles_col__fE11Z"};